import React, { Component } from 'react';
import { connect } from 'react-redux';
import Blank from '../../hoc/Blank/Blank';
import Table from '../../components/UI/Table/Table';
import Spinner from '../../components/UI/Spinner/Spinner';
import AddNewDriverButtons from '../../components/DriverButtons/AddNewDriverButtons';
import Modal from '../../components/UI/Modal/Modal';
import DeleteDriverWarningModal from '../../components/SuccessModals/DeleteDriverWarningModal/DeleteDriverWarningModal';
import * as actions from '../../store/actions/index';
import 'react-toastify/dist/ReactToastify.min.css';
import { ToastContainer, toast } from 'react-toastify';

let driverId = 0;
let deleting= false;
class Drivers extends Component {
 
  state = {
    showEditDriver: false,
    showSuccess: false,
    driverId: 0,
    editDriver: null,
    updated: false,
    delete: false
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.onGetDrivers();
  }

  componentDidUpdate(prevProps) {
    if (this.props.result != "0" && this.props.result != '') {
      let message = "The driver was successfully added.";
      if (this.props.result == "updated") {
        message = "The driver was successfully updated.";
      }
      if (this.props.result == "deleted") {
        message = "The driver was successfully deleted.";
      }
      if (!this.state.result || this.state.result != this.props.result) {
        this.setState({ result: this.props.result });
        toast(message);
      }
    }
  }

  deleteHandler = (e,did) => {
    this.setState({ delete: true, driverId: did });
    deleting = true;
    driverId  = did
  }

  cancelDeleteHandler = () => {
    this.setState({ showEditOrder: false }, () => {
      this.setState({ delete: false })
    });
    deleting = false;
  }

  confirmDeleteHandler = () => {
    this.setState({ showEditOrder: false }, () => {
      this.setState({ delete: false });
    });
    deleting = false;

    this.props.onDeleteDriver(driverId);
  }

  addDriver = () => {
    this.props.history.push('/addDriver');
  }


  showDriver = (e) => {
    if (!deleting) {
      this.setState({ result: "" });
      let did = e.currentTarget.getAttribute('oid');
      this.props.onLoadDriver(did);
      
      this.props.history.push('/adminEditDriver?' + did);
    }
  }


  render() {
     if (this.props.drivers) {
      var data = [];
      let pl = "15px";
      let fifty = "50px";
      let oneFifty = "150px";
      let seventyFive = "75px";
      let oneHundred = "100px";
      if (window.innerWidth < 500) {
        pl = "5px";
        fifty = "40px";
        oneFifty = "100px";
        seventyFive = "50px";
        oneHundred = "75px";
      }
      for (let k in this.props.drivers) {
        let driver = this.props.drivers[k];
          data.push({
            oid: driver.driverId, data: [
              {
                oid: driver.driverId,
                type: 'button',
                label: 'Delete',
                style: {paddingleft: pl, textAlign: 'right' }
            },  
            {
              value: driver.carNumber,
              style: { paddingLeft: pl}
            },
            {
              value: driver.firstName + ' ' + driver.lastName,
              style: {paddingLeft: pl }
            },
            {
              value: driver.phone,
              style: { paddingLeft: pl }
            },
            {
              value: driver.numberOfBags,
              style: { paddingLeft: pl }
            }
            ]
          }
          )
        }
      


      var header = [        
        {
          name: "",
          style: { paddingLeft: pl }
        },
        {
        name: "Car #",
        style: { paddingLeft: pl}
      },
      {
        name: "Name",
        sort: "name",
        style: { paddingLeft: pl }
      },
      {
        name: "Phone",
        sort: "phone",
        style: { paddingLeft: pl }
      },
      {
        name: "# Bags",
        style: { paddingLeft: pl }
      }
    ];

    
      let modalDelete = null;
      if (this.state.delete) {
        modalDelete = <DeleteDriverWarningModal delete={this.confirmDeleteHandler} cancel={this.cancelDeleteHandler}></DeleteDriverWarningModal>
      }

      return (

        <Blank>
          <ToastContainer autoClose={3000} />
          <AddNewDriverButtons onAddDriver={this.addDriver} />
          <Table header={header} data={data} onClick={this.deleteHandler} editPopupHandler={this.showDriver}></Table>
          <Modal show={this.state.delete} modalClosed={this.cancelDeleteHandler}>
            {modalDelete}
          </Modal>

        </Blank>
      );
      }
      else {
        return (
          <div>
            <Spinner />
          </div>
        );
      }
  }
}

const mapStateToProps = state => {
  return {
    drivers: state.orders.drivers
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetDrivers: () => dispatch(actions.getDrivers()),
    onDeleteDriver: (driverId) => dispatch(actions.deleteDriver(driverId)),
    onLoadDriver: (driverId) => dispatch(actions.loadDriver(driverId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Drivers);


// WEBPACK FOOTER //
// ./src/containers/Drivers/Drivers.js